const headerBar = document.querySelector('.js-header-bar');

if (headerBar) {
    // Sticky scroll vars
    const delta       = 5;
    let didScroll     = false;
    let lastScrollTop = 0;
    let navbarHeight  = 0;
    let previousWidth = window.innerWidth;

    navbarHeight = getNavbarHeight();

    /* Listeners */
    window.addEventListener('scroll', () => { didScroll = true; });
    window.addEventListener('resize', vpDebounce(handleViewportChange, 200));

    setInterval(() => {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    setInitialState();

    function hasScrolled() {
        let st = window.scrollY;
        if (Math.abs(lastScrollTop - st) <= delta) {
            return;
        }
        if (st > lastScrollTop && st > navbarHeight) {
            headerBar.setAttribute('is-sticky', 'false')
            headerBar.classList.add('nav-hidden');
        } else {
            headerBar.classList.remove('nav-hidden');
            if (st + window.innerHeight < getDocHeight() && st > navbarHeight) {
                headerBar.setAttribute('is-sticky', 'true');
            }
            if (st === 0) headerBar.setAttribute('is-sticky', 'false');
        }
        lastScrollTop = st;
    }

    function getDocHeight() {
        return Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight
        );
    }

    function handleViewportChange() {
        const currentWidth = window.innerWidth;
        if (currentWidth !== previousWidth) {
            previousWidth = currentWidth;
            navbarHeight = getNavbarHeight();
        }
    }

    function setInitialState() {
        hasScrolled();
        headerBar.classList.add('is-initialised');
        setTimeout(() => headerBar.classList.add('animate'), 300);
    }

    function vpDebounce(callback, delay) {
        let timeoutId;
        return function () {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
            callback.apply(this, arguments);
            }, delay);
        };
    }

    function getNavbarHeight() {
        const videoBanner = document.querySelector('.js-scrub-banner');
        /* if (videoBanner) alert(videoBanner.getAttribute('data-scrub-height')); */
        return (videoBanner) ? videoBanner.offsetHeight: headerBar.offsetHeight;
    }
}